import { z } from 'zod'

export const TPromptSchema = z.object({
  uuid: z.string().default(''),
  name: z.string().default(''),
  scope: z
    .object({
      uuid: z.string().default(''),
      name: z.string().default(''),
      accessLevel: z.enum(['PUBLIC', 'SHARED', 'PRIVATE']).default('PUBLIC')
    })
    .optional(),
  instructions: z
    .array(
      z.object({
        template: z.string().default(''),
        assistantPrefill: z.string().nullable().optional(),
        model: z.object({
          uuid: z.string().default(''),
          name: z.string().default(''),
          scope: z
            .object({
              uuid: z.string().default(''),
              name: z.string().default(''),
              accessLevel: z.enum(['PUBLIC', 'SHARED', 'PRIVATE']).default('SHARED')
            })
            .optional()
        }),
        temperature: z.number().nullable().optional()
      })
    )
    .default([])
})

export type TPrompt = z.infer<typeof TPromptSchema>
